import { createTheme } from '@mui/material/styles';

/**
 * App-wide Material UI theme. Keeps the existing purple brand (the #667eea→#764ba2
 * gradient used across the app and the Cognito Hosted UI) as the primary color so
 * the MUI redesign stays visually consistent with the sign-in page.
 */
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#667eea', dark: '#5a67d8', contrastText: '#ffffff' },
    secondary: { main: '#764ba2' },
    success: { main: '#2ecc71' },
    info: { main: '#3498db' },
    warning: { main: '#f39c12' },
    error: { main: '#e74c3c' },
    background: { default: '#eef1fb', paper: '#ffffff' },
    text: { primary: '#2d3748', secondary: '#4a5568' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Segoe UI", system-ui, -apple-system, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 700 },
    h2: { fontSize: '1.5rem', fontWeight: 700 },
    h3: { fontSize: '1.15rem', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { variant: 'contained' },
      styleOverrides: { root: { paddingInline: 20, paddingBlock: 10 } },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});

// The app's signature gradient, reused for headers and primary surfaces.
export const BRAND_GRADIENT = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';

export default theme;
